<!--
 * @Description: 对账单信息组件
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-05-22 09:33:55
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="traderecord" :back-url-query="{ activeType: 'statement' }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item>对账单查询</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-statement bizcomp ' + className">
            <div class="statement-content-header">
                <div class="statement-title">
                    开放式基金交易对账单
                    <a
                        class="down-contain"
                        :href="downLoadUrl"
                        download="对账单信息"
                        target="_blank"
                    >
                        下载
                    </a>
                </div>
                <div class="statement-info">
                    <el-row>
                        <el-col class="statement-info-title">客户名称：</el-col>
                        <el-col class="statement-info-text">
                            {{ info.custname }}
                        </el-col>
                        <el-col class="statement-info-title">起始日期：</el-col>
                        <el-col class="statement-info-text">
                            {{ $util.fmtDate(begindate) }}
                        </el-col>
                    </el-row>
                    <el-row class="margin-t-12">
                        <el-col class="statement-info-title">基金账号：</el-col>
                        <el-col class="statement-info-text">
                            {{ info.taaccountid }}
                        </el-col>
                        <el-col class="statement-info-title">截止日期</el-col>
                        <el-col class="statement-info-text">
                            {{ $util.fmtDate(enddate) }}
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="statement-assets-content">
                <div class="statement-bar-info">
                    <div class="bar"></div>
                    <div class="bar-title">账户资产情况</div>
                    <div class="bar-desc">(单位：人民币/美元)</div>
                </div>
                <div>
                    <el-table :data="assetList" style="width: 100%" class="tab-list-tit">
                        <div slot="empty" class="auto-in-null"></div>
                        <el-table-column
                            prop="fundname"
                            label="基金名称和代码"
                            width="288px"
                            align="left"
                            :formatter="formatterFundName"
                        />
                        <el-table-column
                            prop="fundvol"
                            label="账户份额余额"
                            align="right"
                        ></el-table-column>
                        <el-table-column
                            prop="nav"
                            label="单位净值"
                            align="right"
                        ></el-table-column>
                        <el-table-column
                            prop="fundmarketvalue"
                            label="基金资产市值"
                            align="right"
                        ></el-table-column>
                        <el-table-column
                            prop="floatprofit"
                            label="盈亏情况"
                            align="right"
                        ></el-table-column>
                        <el-table-column
                            prop="income"
                            label="未付收益①"
                            align="right"
                        ></el-table-column>
                        <el-table-column
                            prop="defdividendmethod"
                            label="当前分红方式"
                            align="right"
                        ></el-table-column>
                        <el-table-column
                            prop="distributorname"
                            label="销售渠道"
                            align="center"
                        ></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="statement-trade-content">
                <div class="statement-bar-info">
                    <div class="bar"></div>
                    <div class="bar-title">交易明细</div>
                </div>
                <div>
                    <el-table :data="transList" style="width: 100%" class="tab-list-tit">
                        <div slot="empty" class="auto-in-null"></div>
                        <el-table-column
                            prop="fundname"
                            label="基金名称"
                            width="288px"
                            align="left"
                        />
                        <el-table-column
                            prop="businessname"
                            label="业务类型"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="confirmedamount"
                            label="确认金额"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="nav"
                            label="申请日净值"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="charge"
                            label="手续费"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="confirmedvol"
                            label="确认份额"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="distributorname"
                            label="销售渠道"
                            align="center"
                        ></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="statement-profit-content">
                <div class="statement-bar-info">
                    <div class="bar"></div>
                    <div class="bar-title">分红明细</div>
                </div>
                <div>
                    <el-table :data="dividendList" style="width: 100%" class="tab-list-tit">
                        <div slot="empty" class="auto-in-null"></div>
                        <el-table-column prop="fundname" label="基金名称" align="center" />
                        <el-table-column
                            prop="defdividendmethod"
                            label="分红方式"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="dividentdate"
                            label="分红日期"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="perunit"
                            label="单位分红"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="basisforcalculatingdividend"
                            label="持有份额"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="dividendcash"
                            label="分红金额"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="registernav"
                            label="权益登记日净值"
                            width="125px"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="realshares"
                            label="分红转份额"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="lastfundvol"
                            label="分红后份额"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="distributorname"
                            label="销售渠道"
                            align="center"
                        ></el-table-column>
                    </el-table>
                </div>
                <div class="margin-t-20">
                    <el-table :data="xjbDividendList" style="width: 100%" class="tab-list-tit">
                        <div slot="empty" class="auto-in-null"></div>
                        <el-table-column
                            prop="fundname"
                            label="基金名称"
                            width="120px"
                            align="center"
                        />
                        <el-table-column
                            prop="dividentbegindate"
                            label="分红起止日期"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="defdividendmethod"
                            label="分红方式"
                            width="120px"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="dividendcash"
                            label="期间累计分红金额"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="realshares"
                            label="期间累计分红结转份额"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="distributorname"
                            label="销售渠道"
                            align="center"
                        ></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="bottom-tip">
                ①：未付收益是指从最近一次收益分配日起至本账单发送日期间的最新未付收益。
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";

export default {
    name: "Statement",
    components: {},
    mixins: [mixin],
    data() {
        return {
            assetList: [],
            transList: [],
            dividendList: [],
            xjbDividendList: [],
            info: {},
            begindate: "",
            enddate: "",
            downLoadUrl: ""
        };
    },
    mounted() {
        this.begindate = this.$route.query.begindate;
        this.enddate = this.$route.query.enddate;
        this.info = this.$cache.getUser();
        this.downLoadUrl =
            this.$util.fileUploadPath("/sale-mid-ump/file/statementsPdfDownload") +
            "?token=" +
            this.$cache.getSessionToken() +
            "&begindate=" +
            this.begindate +
            "&enddate=" +
            this.enddate;
        this.getCrmStatements();
    },
    methods: {
        formatterFundName(row, column, value) {
            return row.fundname + "(" + row.fundcode + ")";
        },
        async getCrmStatements() {
            const res = await userApi.qryCrmStatements({
                begindate: this.begindate,
                enddate: this.enddate
            });
            if (res.data) {
                this.assetList = res.data.assetList ? res.data.assetList : [];
                this.transList = res.data.transList ? res.data.transList : [];
                this.dividendList = res.data.dividendList ? res.data.dividendList : [];
                this.xjbDividendList = res.data.xjbDividendList ? res.data.xjbDividendList : [];
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-statement {
    .statement-content-header {
        padding: 20px;
        .statement-title {
            font-size: 20px;
            font-weight: 500;
            color: #333333;
            display: flex;
            justify-content: space-between;
            .down-contain {
                width: 101px;
                text-align: center;
                height: 40px;
                line-height: 40px;
                border-radius: 2px;
                background: #f1f1f1;
                font-size: 14px;
                font-weight: normal;
                color: #666666;
                cursor: pointer;
            }
        }
        .statement-info {
            margin-top: 19px;
            padding: 16px;
            font-size: 14px;
            font-weight: normal;
            color: #666666;
            box-sizing: border-box;
            border: 1px solid #f1f1f1;
            .statement-info-title {
                width: 75px;
            }
            .statement-info-text {
                width: 480px;
                height: 21px;
                line-height: 21px;
                font-size: 16px;
                font-weight: normal;
                color: #333333;
            }
        }
    }
    .statement-assets-content,
    .statement-trade-content,
    .statement-profit-content {
        padding: 0 20px;
        .statement-bar-info {
            display: flex;
            align-items: center;
            .bar {
                width: 3.71px;
                height: 16px;
                background: #e60012;
            }
            .bar-title {
                font-size: 16px;
                font-weight: 500;
                color: #333333;
                margin-left: 6.29px;
            }
            .bar-desc {
                font-size: 14px;
                font-weight: normal;
                color: #999999;
                margin-left: 8px;
            }
        }
    }
    .statement-trade-content {
        margin-top: 20px;
    }
    .statement-profit-content {
        margin-top: 20px;
    }
    .bottom-tip {
        font-size: 16px;
        font-weight: normal;
        color: #333333;
        padding: 0 20px 20px;
    }
    .tab-list-tit {
        margin-top: 12px;
        border-left: 1px solid #f1f1f1;
        border-right: 1px solid #f1f1f1;
    }
    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
            height: 50px !important;
            border: 1px solid #f1f1f1;
            font-size: 14px;
            font-weight: normal;
            color: #666666;
        }
        td {
            height: 50px !important;
            border: 1px solid #f1f1f1;
        }
        .el-table__empty-block {
            min-height: 50px !important;
        }
    }
    .margin-t-12 {
        margin-top: 12px;
    }
}
</style>
